import React from 'react';
import { CnReadonly } from '@/components/cn-readonly';
import classNames from 'classnames';
import isFunction from 'lodash/isFunction';
import BaseSelect from './base-select';
import { getPreviewValue } from './util';
const CnSelect = (props, ref) => {
    const { isPreview, readOnly, previewClassName: previewClassNameProp, previewStyle, renderPreview, prefix = 'cn-ui-m-', size = 'medium', } = props;
    // notice: if mode=single, will return a non-array value
    const values = getPreviewValue(props);
    const previewClassName = classNames(previewClassNameProp, `${prefix}select-preview--${size}`);
    // render preview element
    if (isPreview || readOnly) {
        if (isFunction(renderPreview)) {
            return (React.createElement("div", { className: previewClassName, style: previewStyle }, renderPreview(values, props)));
        }
        let directRenderVal = '';
        if (Array.isArray(values)) {
            directRenderVal = values.map((v) => v.label).join(',');
        }
        else if (values && values.label) {
            directRenderVal = values.label;
        }
        return (React.createElement("div", { className: previewClassName, style: previewStyle },
            React.createElement(CnReadonly, null, directRenderVal)));
    }
    return React.createElement(BaseSelect, { ...props, ref: ref });
};
CnSelect.displayName = 'CnSelect';
export default React.forwardRef(CnSelect);
